<template>
  <div class="headsinfo">
    <v-head></v-head>
    <div class="infor_bg">
      <img src="../assets/pic02.png" alt="" />
      <div class="infor_txt">
        <div class="title">
          信息化产品
        </div>
        <div class="txt">
          Informatization Products
        </div>
      </div>
    </div>

    <div class="infor_group">
      <div class="infor_content">
        <div class="content" @click="gotoMoreInfor">
          <div class="content_wrap">
            <p class="title">基于RFID的接地线管理系统</p>
            <img src="../assets/pic1.png" alt="" />
            <div class="right_txt">
              <span>了解更多</span>
              <span class="el-icon-right"></span>
            </div>
          </div>
        </div>
        <div class="content end" @click="gotoMoreInfor1">
          <p class="title">用户停电互动智能管理系统</p>
          <img src="../assets/img11.png" alt="" />
          <div class="right_txt">
            <span>了解更多</span>
            <span class="el-icon-right"></span>
          </div>
        </div>
      </div>
      <div class="infor_content1">
        <div class="content" @click="gotoMoreInfor2">
          <div class="content_wrap">
            <p class="title">基于人工智能的电系操作指令票自动识别</p>
            <img src="../assets/img12.png" alt="" />
            <div class="right_txt">
              <span>了解更多</span>
              <span class="el-icon-right"></span>
            </div>
          </div>
        </div>
        <div class="content end" @click="gotoMoreInfor3">
          <p class="title">基于经纬度信息的辅助室外巡检导航系统</p>
          <img src="../assets/img13.png" alt="" />
          <div class="right_txt">
            <span>了解更多</span>
            <span class="el-icon-right"></span>
          </div>
        </div>
      </div>
      <div class="infor_content1">
        <div class="content" @click="gotoMoreInfor4">
          <div class="content_wrap">
            <p class="title">医疗健康分析平台</p>
            <img src="../assets/jk1.png" alt="" />
            <div class="right_txt">
              <span>了解更多</span>
              <span class="el-icon-right"></span>
            </div>
          </div>
        </div>
        <!-- <div class="content end" @click="gotoMoreInfor3">
          <p class="title">基于经纬度信息的辅助室外巡检导航系统</p>
          <img src="../assets/img13.png" alt="">
          <div class="right_txt">
            <span>了解更多</span>
            <span class="el-icon-right"></span>
          </div>
        </div> -->
      </div>
      <!-- <div class="infor_content2">
        <div class="content">
          <div class="content_wrap">
            <p class="title">基于台区TTU设备故障快速定位系统</p>
            <img src="../assets/img12.png" alt="">
            <div class="right_txt">
              <span>了解更多</span>
              <span class="el-icon-right"></span>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <v-foot class="infor_foot"></v-foot>
  </div>
</template>
<script>
import router from "../router/index.js";
export default {
  methods: {
    gotoHome() {
      router.push("/");
    },
    gotoMoreInfor() {
      router.push("/moreInfor");
    },
    gotoMoreInfor1() {
      router.push("/moreInfor1");
    },
    gotoMoreInfor2() {
      router.push("/moreInfor2");
    },
    gotoMoreInfor3() {
      router.push("/moreInfor3");
    },
    gotoMoreInfor4() {
      router.push("/moreInfor10");
    }
  }
};
</script>
<style scoped>
.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.infor_bg img {
  margin-top: 75px;
  width: 100%;
  height: 600px;
}
.infor_txt {
  position: absolute;
  top: 280px;
  right: 420px;
  color: #fff;
}
.infor_txt .title {
  font-size: 58px;
}
.infor_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.infor_text {
  display: flex;
}
.infor_group {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.infor_content {
  display: flex;
  margin-top: 50px;
}
.infor_content .content {
  background-color: #fff;
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  padding: 30px 50px;
  margin-right: 100px;
}
.infor_content .title {
  font-size: 20px;
  color: #333;
  font-weight: 600;
}
.infor_content img {
  margin-top: 20px;
  width: 370px;
  height: 180px;
}
.infor_content .right_txt {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  width: 370px;
  font-size: 15px;
  color: #999;
}
.infor_content .el-icon-right {
  font-size: 20px;
}
.infor_content1 {
  display: flex;
  /* position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 450px; */
  margin-top: 50px;
}
.infor_content1 .content {
  background-color: #fff;
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  padding: 30px 50px;
  margin-right: 100px;
}
.infor_content1 .title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.infor_content1 img {
  margin-top: 20px;
  width: 370px;
  height: 180px;
}
.infor_content1 .right_txt {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  width: 370px;
  font-size: 15px;
  color: #999;
}
.infor_content1 .el-icon-right {
  font-size: 20px;
}
.infor_foot {
  position: relative;
  margin-top: 1200px;
}
.infor_content .end {
  margin-right: 0;
}
.infor_content1 .end {
  margin-right: 0;
}
.infor_content2 {
  display: flex;
  margin-top: 50px;
}

.infor_content2 .title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.infor_content2 img {
  margin-top: 20px;
  width: 370px;
  height: 180px;
}
.infor_content2 .right_txt {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  width: 370px;
  font-size: 15px;
  color: #999;
}
.infor_content2 .title {
  width: 370px;
}
.infor_content2 .el-icon-right {
  font-size: 20px;
}
.infor_content2 .content {
  background-color: #fff;
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  padding: 30px 50px;
  margin-right: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Information.vue